import React from 'react';
import classNames from 'classnames';
import './ChartTypePickerEditor.less';
import { IEditorProps } from './Editor';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { ChartType } from '@decisions/server/DecisionsFramework/Design/Report/ChartType';
import { Icon } from 'components/icons/Icon';
import { getChildValue } from 'components/property-editors/utils/ProviderNodeUtils';
import { EditorLabel } from './EditorLabel';

interface IChartTypePickerEditorProps extends IEditorProps {}

const getClassName = () => classNames('dpc-chart-type-picker-editor');
const getButtonClassName = (current = false) =>
  classNames('dpc-chart-type-picker-editor__button', {
    'dpc-chart-type-picker-editor__button--active': current,
  });

/**
 * Editor presenting icon buttons for available chart types that a chart could be converted to.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ChartTypePickerEditor({ child, path, onChange }: IChartTypePickerEditorProps) {
  const compatibleChartTypes: ChartType[] = getEditorConfigValue(child, 'CompatibleChartTypes');
  const compatibleChartTypeLabels: string[] = getEditorConfigValue(child, 'ChartTypeNames');
  const value: ChartType = getChildValue(child);

  return (
    <EditorLabel editor={child} path={path}>
      <section className={getClassName()}>
        {compatibleChartTypes.map((type, i) => (
          <button key={type} className={getButtonClassName(type === value)} onClick={() => onChange(`${type}`, path)}>
            <Icon className={getIconForChartType(type)} />
            <div className="dpc-chart-type-picker-editor__button-label">{compatibleChartTypeLabels[i]}</div>
          </button>
        ))}
      </section>
    </EditorLabel>
  );
}

function getIconForChartType(type: ChartType) {
  switch (type) {
    case ChartType.Bars:
      return 'dpc-chart-type-picker-editor__bars-icon';
    case ChartType.StackedBars:
      return 'dpc-chart-type-picker-editor__stacked-bars-icon';
    case ChartType.Columns:
      return 'dpc-chart-type-picker-editor__columns-icon';
    case ChartType.Areas:
      return 'dpc-chart-type-picker-editor__area-icon';
    case ChartType.Pies:
      return 'dpc-chart-type-picker-editor__pie-icon';
    case ChartType.Ring:
      return 'dpc-chart-type-picker-editor__ring-icon';
    case ChartType.Lines:
      return 'dpc-chart-type-picker-editor__line-icon';
    case ChartType.Dots:
      return 'dpc-chart-type-picker-editor__dots-icon';
    case ChartType.Bubbles:
      return 'dpc-chart-type-picker-editor__bubbles-icon';
    case ChartType.Funnel:
      return 'dpc-chart-type-picker-editor__funnel-icon';
    default:
      return 'dpc-chart-type-picker-editor';
  }
}
